/** Roles that must pick a CDS scope before offline sync (not full tenant). RDDO excluded. */
export const WIDE_OFFLINE_ROLES = [
  'RET',
  'REM',
  'RES',
  'REC',
  'RP',
  'RETP',
  'REMP',
  'RESP',
  'RECP',
  'ADMIN',
  'SUPERADMIN',
] as const;

export type WideOfflineRole = (typeof WIDE_OFFLINE_ROLES)[number];

export const isWideOfflineRole = (role: string | undefined): boolean =>
  !!role && (WIDE_OFFLINE_ROLES as readonly string[]).includes(role);

/** Wide / national roles: no automatic sync on login (CDS scope + manual resync). */
export const skipsLoginAutoSync = (role: string | undefined): boolean =>
  isWideOfflineRole(role);
